import { Auth } from 'Shared/auth';
import { listenGlobal } from 'Shared/utils/global-events';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

const track = (action, params = {}) =>
   trackAnalyticsCustomEvent({
      eventCategory: 'Document Teaser',
      eventAction: `Document Teaser - ${action}`,
      ...params,
   });

onDomReady(() => {
   track('View');
   listenGlobal('login.success', response =>
      track('Login Success', {
         method: response.from ?? 'unknown',
         new_user: response.newUser ? 'true' : 'false',
      })
   );

   const openLoginModal = () => {
      Auth.required({
         onAuthorize: () => window.location.reload(),
         onCancel: () => track('Login Modal Dismiss'),
      });
   };

   document.getElementById('documentTeaserLogin').addEventListener('click', event => {
      event.preventDefault();
      track('Login CTA Click');
      openLoginModal();
   });

   openLoginModal();
});
